import React from 'react';

import { useLotMatrix } from '../hooks/useLotMatrix';
import { ExclusionMatrix } from './ExclusionMatrix';
import { RoleLevelMatrices } from './RoleLevelMatrices';

export const ExclusionMatrices = ({ resource, id, lotId, ...matrixProps }) => {
  const matrix = useLotMatrix(resource, id, lotId);

  return (
    <RoleLevelMatrices
      {...matrix}
      emptyText="Add roles to this lot before excluding them"
      renderMatrix={(group) => <ExclusionMatrix {...group} {...matrixProps} />}
    />
  );
};
